import styled from 'styled-components';

export const InfoList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
  margin: 0;
`;
